import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './chatContent.css'
import Loading from '../componentKit2/Loading'
import emptyChat from './imgs/ico-chat.svg'
import classnames from 'classnames'
import moment from 'moment'

const dateFormat = (date, bool) => {
  let newDate

  if (date) {
    let arr = date.split('-')
    let arrTime = date.split('T')
    let age
    if (bool) {
      newDate = arrTime[1].slice(0, 8) + ',' + ' ' + arr[2].slice(0, 2) + '-' + arr[1] + '-' + arr[0]
      return newDate
    }
    newDate = arr[2].slice(0, 2) + '-' + arr[1] + '-' + arr[0]

    age = Math.floor((new Date() - new Date(arr[0], arr[1] - 1, arr[2].slice(0, 2))) / 3600 / 1000 / 24 / 365.25)
    return {newDate, age}
  }
  return 'Нет данных'
}
/**
 *  Компонент ChatContent.
 *  Используется для вывода контента чата
 *
 */
class ChatContent extends Component {
  /**
   * @memberof ChatContent
   * @prop {object} propTypes - the props that are passed to this component
   * @prop {func} propTypes.list Массив сообщений
   * @prop {func} propTypes.userId Номер Пользователя
   * @prop {object} propTypes.type  Тип чата
   * */

  static propTypes = {
    list: PropTypes.array.isRequired,
    userId: PropTypes.number.isRequired,
    type: PropTypes.number
  }

  shouldComponentUpdate(nextProps){
    return (
         nextProps.userId !== this.props.userId
      || nextProps.list !== this.props.list
      || nextProps.isFetching !== this.props.isFetching
      || nextProps.isActive !== this.props.isActive
      || nextProps.miniChatSmall !== this.props.miniChatSmall
    )
  }

  render() {
    const {list, userId, isFetching, isActive, gender, miniChat, isFetchingChat, miniChatSmall} = this.props
    let listArr = list ? list : []
    const chatContentClass = classnames('chatContent', styles.chatContent, {
      [styles.chatContentActive]: isActive,
      [styles.smallChatHeigth]: miniChatSmall,
      [styles.miniChatContent]: miniChat && !miniChatSmall,
      [styles.border]: miniChat
    })
    console.log('chatContenttt')
    console.log(this.props)
    console.log(listArr)
    return (
      <div className={chatContentClass}>
        { listArr.length  ?
          <div
            ref='chat'
            id='chat-list'
            className={classnames({
              [styles.chatMessagesMini]: miniChat,
              [styles.chatMessages] :!miniChat
            })}>
          {
            listArr.map(({ id, userInfo, date, text, isRead, isSystem }, index) => {
              let liStyle
             let data = null
              if(!index){
                data = moment(date).format('LL')
              } else {
                data = moment(date).format('LL') !== moment(listArr[index - 1].date).format('LL') ? moment(date).format('LL') : null
              }
                if (isSystem) {
                liStyle = styles.chatMsgSystem
              } else if (userId === userInfo.id) {
                liStyle = styles.chatMsgYou
              } else {
                liStyle = styles.chatMsgSomeone
              }
              let item = !(userId === userInfo.id) ?
                <div className={liStyle}>
                  {!isSystem ?
                    <div className={styles.chatMsgAva}>
                      <img
                        className={styles.chatMsgAvaImg}
                        src={userInfo.photo ? userInfo.photo : (userInfo.gender === 'male' ? '/assets/img/png/boy.png' : '/assets/img/png/girl.png')} alt=""
                      />
                    </div> : null }

                  <div className={miniChat? styles.chatMsgContentMini: styles.chatMsgContent}>
                    {!miniChat && <div className={styles.dateSomeone}>
                    {/*  <p className={styles.chatMsgTime}>{dateFormat(date, true)}</p>*/}
                    {/*  <p className={styles.chatMsgName}>
                        {isSystem ? 'Системное сообщение' : `${userInfo.firstName || ''} ${userInfo.lastName || ''}`}
                      </p>*/}
                    </div>
                    }

                    <div className={styles.chatMsgText}>

                      <div className={styles.chatMsgTextMini}>{isSystem ? 'Системное сообщение' : `${userInfo.firstName || ''} ${userInfo.lastName || ''}`}</div>
                      <div className={styles.tLeft}>{text}</div>
                      </div>
                  </div>
                </div>
                :
                <div className={liStyle}>
                  <div className={styles.chatMsgContent}>
                    {!miniChat &&
                    <div className={isSystem ? styles.dateSystem : styles.date}>
                      {/*<p className={styles.chatMsgTime}>{dateFormat(date, true)}</p>*/}
                      <p className={styles.chatMsgName}>
                        {isSystem ? 'Системное сообщение' : `${userInfo.firstName || ''} ${userInfo.lastName || ''}`}
                      </p>
                    </div>
                    }

                    <div className={classnames(styles.chatMsgText,{[styles.bgMini]:miniChat})}>
                      {/*{miniChat &&
                      <div className={styles.chatMsgTextMini}>{isSystem ? 'Системное сообщение' : `${userInfo.firstName || ''} ${userInfo.lastName || ''}`}</div>}*/}
                      <div className={styles.tLeft}>{text}</div>
                      </div>
                  </div>
                  {!isSystem ?
                    <div className={styles.chatMsgAva}>
                      <img
                        className={styles.chatMsgAvaImg}
                        src={userInfo.photo ? userInfo.photo : (userInfo.gender === 'male' ? '/assets/img/png/boy.png' : '/assets/img/png/girl.png')} alt=""
                      />
                    </div>: null }

                </div>

              if(!isRead && (listArr[index-1] ? listArr[index-1].isRead : true)){
                return (
                  <div key={id} className={styles.chatMsgNewWrapper}>
                    <div id='newMessage' style={{display: 'block'}}>
                      <div className={styles.chatMsgNewLine}></div>
                      <div className={styles.chatMsgNew}>Новые сообщения</div>
                    </div>

                    <div id='message-item'>
                      {item}
                    </div>
                  </div>
                )
              }
              return (
                <div key={id}>
                  {data && data !== 'Invalid date' && <div className={styles.data}>{data}</div>}
                  <div id='message-item'>
                    {item}
                  </div>
                </div>

            )})
          }
        </div> : !isFetchingChat ?
            <div className={classnames('chat-empty', {'chat-empty__mini': miniChat && miniChatSmall})}>
              <div className="chat-empty__ico">
                <img className="chat-empty__img" src={emptyChat} alt="emptyChat"/>
              </div>
                <p className="chat-empty__copy">В чате нет сообщений, но ты можешь задать вопрос тренеру прямо сейчас!</p>
            </div>
              : <Loading />}
      </div>
    )
  }
}

export default CSSModules(ChatContent, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/Chat/ChatContent.js